module.exports = __webpack_public_path__ + "static/media/network-signal.9bba4583.svg";